import { Injectable } from '@angular/core';
import { Globals } from 'projects/core/src/globals';
import { WSService } from 'projects/core/src/include/service';
import { Observable, Observer } from 'rxjs';
import { CashRegister } from '../db/cashregister';
import { Filter, FilterAdvanced, Ordering } from 'projects/core/src/include/structures';

@Injectable({
  providedIn: 'root'
})
export class CashregisterService extends WSService<CashRegister> {
  static cashes=[];

  constructor() { super("cashregister")}

  getCountPayment(date,created_from):Observable<any>{
    return Globals.ws.requestUrl<any>("cashregister","getCountPayment",[date,created_from]);
  }


  getCashes(force_download=false):Observable<any[]>{
    
      if(CashregisterService.cashes.length==0 || force_download){
        Globals.ws.requestUrl<any[]>("cashregister","getCashes",[],true,0,100000).subscribe((items:any)=>{
          CashregisterService.cashes=items;
        });
        return Globals.ws.requestUrl<any[]>("cashregister","getCashes",[],true,0,100000);
  
      }else{
  
        function sequenceSubscriber(observer: Observer<any[]>) {
          observer.next(CashregisterService.cashes);
          observer.complete();
          return {unsubscribe() {}};
        }
        
          return new Observable(sequenceSubscriber);
      }
    
      
    
    
    }

  getCashesTotal():Observable<any>{
    return Globals.ws.requestUrl<any>("cashregister","getCashesTotal",[]);
  }

  getBalance(id_cash):Observable<any>{
    return Globals.ws.requestUrl<any>("cashregister","getBalance",[id_cash]);
  }

  addCash(name):Observable<any>{
    return Globals.ws.requestUrl<any>("cashregister","addCashes",[name]);
  }

  deleteCash(id_cash):Observable<any>{
    return Globals.ws.requestUrl<any>("cashregister","deleteCashes",[id_cash]);
  }

  getTotals(filters:Filter[],ordering:Ordering[],advancedFilter:FilterAdvanced[]):Observable<any>{
      return Globals.ws.requestUrl("cashregister","getTotals",this.getSQLWhere(filters,ordering,advancedFilter));
  }

  getCashflowByIdUser(date,id_user):Observable<any>{
    return Globals.ws.requestUrl<any>("cashregister","getCashflowByIdUser",[date,id_user]);
  }
}
